import { menuItems } from 'constants'

export const BaseHeader = props => {
  return (
    <header style={{ backgroundImage: 'linear-gradient(90deg, #f05e22 0%, #f8ad40 100%)' }}>
      <div className="max-w-[1100px] mx-auto text-white flex items-center px-5 lg:px-0">
        <a href="https://rynoinsurance.wpengine.com/">
          <img className="w-[120px] md:w-[170px]" src="/white-logo.png" alt="logo" />
        </a>
        <p className="text-xs md:text-sm font-bold">Transport & Motor Insurance</p>
      </div>

      <div className="bg-[#363b3f] text-white px-5 lg:px-0 py-4">
        <div className="max-w-[1100px] mx-auto flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
          <nav className="flex flex-wrap items-center list-none gap-3 md:gap-5">
            {menuItems.map((item, index) => (
              <li key={index}>
                <a className=" text-white text-sm md:text-base hover:text-primary-main transition" href={item.url}>
                  {item.name}
                </a>
              </li>
            ))}
          </nav>

          <a
            href="https://rynoinsurance.com.au/quote"
            className="inline-flex items-center justify-center text-sm md:text-base font-bold text-white p-2 md:px-6 md:py-3 bg-primary-main rounded-full  transition hover:bg-white hover:text-primary-main">
            Get a quote
          </a>
        </div>
      </div>
    </header>
  )
}
